'use client';
import { isArray } from '../array.js';

/**
 * Если значение является массивом, сохраняет его в неизменном виде.
 * Если не является массивом, оборачивает его в массив.
 *
 * @typeParam T - Элемент массива или значение.
 * @param candidate - Массив или одно значение.
 * @returns Массив элементов типа `T`.
 *
 * @primaryExample
 * arrayOf(1) // [1]
 * arrayOf([1]) // [1]
 *
 * @stable
 * */ const arrayOf = (candidate)=>isArray(candidate) ? candidate : [
        candidate
    ];

export { arrayOf };
//# sourceMappingURL=arrayOf.js.map
